import React from 'react'
import "../../styles/page404.css"
import { Link } from 'react-router-dom'

function Page404() {
  return (
    <>
        <div className="top404">
            <h1>404</h1>
            <h3>Pagina no encontrada</h3>
        </div>
        <div className="bottom404">
            <p>Parece que lo que buscas aun no se encuentra en nuestra pagina.
            </p>
            <div className="button404">
                <Link to="/" className="btn404">Inicio</Link>
            </div>
        </div>
    </>
  )
}

export default Page404
